import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const goToCheckout = () => {
    window.open('https://e8br1p-v6.myshopify.com/cart/53210025689199:1', '_blank', 'noopener,noreferrer');
  };
  return <section className="relative bg-brand-cream overflow-hidden py-16 lg:py-24" data-id="element-115">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-116">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start" data-id="element-117">
          {/* Left: Text */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-118">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-brand-green text-white text-sm font-semibold mb-8" data-id="element-119">
              <Sparkles className="w-4 h-4 text-brand-gold" data-id="element-120" />
              SISTEMA DE CRÉDITO 2026
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-green leading-[1.1] mb-8" data-id="element-121">
              Aprende a dominar tu crédito en USA y construye una{' '}
              <span className="text-brand-gold italic" data-id="element-122">base financiera</span>{' '}
              <span className="italic" data-id="element-123">real</span>
            </h1>

            <p className="text-lg text-brand-green/80 mb-10 max-w-xl leading-relaxed" data-id="element-124">
              Un sistema claro, práctico y paso a paso para entender, mejorar y
              mantener tu crédito en Estados Unidos sin errores costosos.
            </p>

            <motion.button onClick={goToCheckout} className="inline-flex items-center gap-3 px-8 py-4 bg-brand-green hover:bg-brand-dark text-white rounded-full font-bold text-lg transition-all shadow-premium hover:shadow-xl hover:-translate-y-1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-125">
              QUIERO MEJORAR MI CRÉDITO
              <ArrowRight className="w-5 h-5" data-id="element-126" />
            </motion.button>

            <p className="text-sm text-brand-green/60 mt-4" data-id="element-127">
              Acceso inmediato · Pago único · Sin suscripciones
            </p>
          </motion.div>

          {/* Right: Lifestyle Image with Book */}
          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-128">
            <motion.img src="https://cdn.magicpatterns.com/uploads/jqwCWHahSZ9Qxis3hEoMKV/portada_de_como_crear_tu_Sistema_.png" alt="SCORE 700 - Cómo Crear tu Sistema de Crédito en USA" className="w-full max-w-2xl mx-auto drop-shadow-2xl lg:scale-110 origin-top lg:-mt-8" initial={{
            y: 20
          }} animate={{
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-129" />
          </motion.div>
        </div>
      </div>
    </section>;
}